module.exports = __webpack_public_path__ + "teqbahn-assets/media/21.bff464a3.png";